// @ts-check
import { createClock } from '../engine/clock.js';
/** Browser adapter around the deterministic clock. No simulation code knows about RAF.
 * @param {{step:(dt:number)=>void,render:(alpha:number)=>void,active:()=>boolean,now:()=>number,request:(callback:FrameRequestCallback)=>number,cancel:(id:number)=>void}} options
 */
export function createLoop({ step, render, active, now, request, cancel }) {
  let pendingStep = false;
  const clock = createClock((dt) => { pendingStep = false; step(dt); });
  let frame = 0;
  let previous = 0;
  let disposed = false;
  /** @param {number} time */
  function tick(time) {
    frame = 0;
    if (disposed) return;
    clock.advance((time - previous) / 1000);
    previous = time;
    render(clock.alpha);
    if (!disposed && (pendingStep || active())) frame = request(tick);
  }
  function stop() { cancel(frame); frame = 0; pendingStep = false; clock.reset(); }
  return {
    // Every wake must reach a fixed step, including a stationary crouch or a
    // release that clears it. Fast displays can render before that step is due.
    wake() { if (!disposed && !frame) { pendingStep = true; previous = now(); frame = request(tick); } },
    stop,
    dispose() { disposed = true; stop(); },
    get stats() { return clock.stats; },
  };
}
